import React, { useEffect, useRef, useState } from "react";
import {  useSelector } from "react-redux";
import { Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getInitials } from "../../libs/utils";
import useClearDefaultAccountant from "../../customHooks/useClearDefaultAccountant";
import useChangeAccountant from "../../customHooks/useChangeAccountant";

const AccountantList = props => {

  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);

  const {changeAccountantSelected} = useChangeAccountant();
  const inputEl = useRef(null);
  const [arrowSelect, setArrowSelect] = useState("down");
  const selectCompanyPlaceholder = useIntl().formatMessage({
    id: "generic.selectCompanyPlaceholder"
  });

  let arrayAccountant = company.companies.find(el => {
    return el.id === main.clientIdSelected;
  });

  arrayAccountant = arrayAccountant ? arrayAccountant.commercialistiList : [];

  useEffect(() => {
    if (arrowSelect === "up") {
      inputEl.current.focus();
    }
  }, [arrowSelect]);

  const renderAccountantsList = () => {
    return (
      <div style={{ position: "absolute", top: "64px" }}>
        <div
          style={{
            overflow: "auto",
            transform: "translateZ(0px)",
            backgroundColor: "#5a6872",
            width: "390px"
          }}
        >
          <ul className="list-dropdownMenu">
            {arrayAccountant.map((el, index) => {
              return (
                <li
                  key={`arrayAccountant_${index}`}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    changeAccountantSelected(el.id);
                    setArrowSelect("down");
                  }}
                >
                  <div
                    className="optionLiAutoComplete gs-change-company"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    { !el.logoUrl ?
                      <div className="roundUser" style={{ marginRight: "5px" }}>
                        <span>
                          {el.ragioneSociale
                            ? getInitials(el.ragioneSociale)
                            : "N/A"}{" "}
                        </span>
                      </div>
                      : <div className="dbx-header-logo-container" style={{backgroundImage: `url(${el.logoUrl})`}}></div>
                    }
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span>{el.ragioneSociale}</span>
                      <span className="txtSmall"><span style={{ textTransform: "uppercase" }}><FormattedMessage id="generic.fiscalCodeAbbreviation" /></span> {el.codiceFiscale}</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  const actualAccountantName = localStorage.getItem("actualAccountantName");
  const actualAccountantData = arrayAccountant?.find(acc => acc.ragioneSociale === actualAccountantName);
  const studioLogoUrl = actualAccountantData?.logoUrl;

  const {clearDefaultAccountant} = useClearDefaultAccountant();

  return (
    arrayAccountant &&
    arrayAccountant.length > 0 && (
      <>
        <div
          onClick={  arrayAccountant.length > 1 ? e => {
            clearDefaultAccountant();
            setArrowSelect(arrowSelect === "down" ? "up" : "down");
          } : null}
          style={{ cursor: "pointer" }}
          className={
            "clienteEsteso " +
            (main.myType === "STUDIO" ? " clienteEstesoBianco" : "")
          }
        >
          <div className="fakeSelect" style={{display: "flex"}}>
            { studioLogoUrl &&
              <div className="fake-select-logo-container" style={{backgroundImage: `url(${studioLogoUrl})`}}>
              </div>
            }
            <div>
              <span style={{ marginLeft: "10px" }}>
                {arrowSelect === "down" ? (
                  actualAccountantName
                ) : (
                  <Input
                    style={{
                      backgroundColor: "transparent",
                      border: 0,
                      padding: 0,
                      width: "calc(100% - 20px",
                      color: main.myType === "STUDIO" ? "#000" : "#FFF"
                    }}
                    placeholder={selectCompanyPlaceholder}
                    ref={inputEl}
                  />
                )}
              </span>
              <div className="companyCF"> <span style={{ textTransform: "uppercase" }}><FormattedMessage id="generic.fiscalCodeAbbreviation" /></span> {main.accountantSelected}</div>
            </div>
          </div>
        </div>
        {arrowSelect === "up" && renderAccountantsList()}
        {arrayAccountant.length > 1 &&
            <FontAwesomeIcon
              icon={["far", "angle-" + arrowSelect]}
              style={{
                color: main.myType === "STUDIO" ? "#152935" : "#FFF",
                cursor: "pointer",
                fontSize: "20px"
              }}
            />
        }
      </>
    )
  );
};

export default AccountantList;
